import {
  errorNotePrequalificationField,
  prequalificationField,
  prequalificationSection,
  tsb15SectionKeys,
  isTsbTakeoverEligibleOutlet
} from '../../../utils/constant';
import { getFieldValue } from '../../utils';
import { getLocale } from '../../../misc';
import EN from '../../../../EN.json';
import FR from '../../../../FR.json';
import { updatePrequalificationField } from './utils';

const prequalificationSectionHelpers = ({ fieldName, formFields, salesRepOutlet }) => {
  const locale = getLocale();
  const {
    vulcanWebform: { yes }
  } = locale === 'en-US' ? EN : FR;

  const isTsb15Section = tsb15SectionKeys.includes(fieldName);
  const isSpecialOutlet = isTsbTakeoverEligibleOutlet(salesRepOutlet);
  const existingSecurityEquipmentIsNotYes = getFieldValue('existingSecurityEquipment', formFields) !== yes;

  // Return true for TSB 1.5 sections when: not special outlet; or existing security equipment is not "Yes"
  if (isTsb15Section && (!isSpecialOutlet || existingSecurityEquipmentIsNotYes)) {
    return true;
  }

  if(fieldName === 'officialNote' && !isSpecialOutlet) {
    return true;
  }

  if (
    fieldName === prequalificationSection ||
    fieldName === errorNotePrequalificationField
  ) {
    const updatedPrequalificationField = updatePrequalificationField(salesRepOutlet, prequalificationField);
    const prequalificationFieldsValue = updatedPrequalificationField.map(value => {
      return getFieldValue(value, formFields) === yes;
    });

    if (
      fieldName === errorNotePrequalificationField &&
      !prequalificationFieldsValue.includes(true)
    ) {
      return true;
    }
  }
};

export default prequalificationSectionHelpers;
